'use client'

import { useDisclouser } from '@/core/hooks/use-disclosure'
import { Modal } from '@/core/ui/atoms/modal'
import {
  ModalBody,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@heroui/react'
import { ProductDetails } from '../../model/product.model'
import { AddReview } from '../add-review'
import { Button } from '@/core/ui/atoms/button'
import { useAuth } from '@/core/store/auth'
import { QUERY_ROUTES } from '@/core/constants/routes'
import { useUpdateSearchParams } from '@/core/hooks/use-update-search-params'

export function AddReviewModal({ product }: { product: ProductDetails }) {
  const {
    isOpen: toggleActivateOpen,
    onOpen: openToggleActivate,
    onClose: closeToggleActivate,
  } = useDisclouser()

  const { updateSearchParam } = useUpdateSearchParams()

  const { isAuthenticated } = useAuth()

  const openLogin = () => {
    updateSearchParam(
      { [QUERY_ROUTES.login.name]: QUERY_ROUTES.login.value },
      { clientOnly: true },
    )
  }

  const canReview = product.is_ordered_by_user

  return (
    <>
      {canReview ? (
        <Button
          onClick={isAuthenticated ? openToggleActivate : openLogin}
          variant='outlined'
          className='h-11 w-full'
        >
          Add review
        </Button>
      ) : (
        <Popover placement='bottom'>
          <PopoverTrigger>
            <Button
              variant='outlined'
              className='h-11 w-full opacity-60'
            >
              Add review
            </Button>
          </PopoverTrigger>

          <PopoverContent className='max-w-xs p-4 text-sm'>
            You must purchase this product before writing a review.
          </PopoverContent>
        </Popover>
      )}
      <Modal
        isOpen={toggleActivateOpen}
        disableBackdropDismiss
        onClose={closeToggleActivate}
        size='md'
        className='max-h-[90%] max-w-lg overflow-y-hidden rounded-2xl sm:max-h-full'
      >
        <ModalBody className='p-6'>
          <AddReview product={product} onClose={closeToggleActivate} />
        </ModalBody>
      </Modal>
    </>
  )
}
